import { render, staticRenderFns } from "./ProblemEdit.vue?vue&type=template&id=0637887f&"
import script from "./ProblemEdit.vue?vue&type=script&lang=js&"
export * from "./ProblemEdit.vue?vue&type=script&lang=js&"
import style0 from "./ProblemEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})


/* hot reload */
if (module.hot) {
  var api = require("/var/apps/oil/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0637887f')) {
      api.createRecord('0637887f', component.options)
    } else {
      api.reload('0637887f', component.options)
    }
    module.hot.accept("./ProblemEdit.vue?vue&type=template&id=0637887f&", function () {
      api.rerender('0637887f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ProblemEdit.vue"
export default component.exports